import { render, staticRenderFns } from "./VideoEditor.vue?vue&type=template&id=78e5773a&scoped=true&"
import script from "./VideoEditor.vue?vue&type=script&lang=ts&"
export * from "./VideoEditor.vue?vue&type=script&lang=ts&"
import style0 from "./VideoEditor.vue?vue&type=style&index=0&id=78e5773a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e5773a",
  null
  
)

export default component.exports